module.exports = __webpack_public_path__ + "static/pci-246000f8d1540ee5a5756fbc798bec63.png";